const tipo_relatorio = document.querySelector("#tipo_relatorio");
const prodserv = document.querySelector("#prodserv");
const periodo_dias = document.querySelector("#periodo_dias");
const cliente_relatorio = document.querySelector("#clientes_relatorio");
const data = document.querySelector("#data_con");

const hideElement = (el) => (el.style.display = "none");

const showElement = (el) => (el.style.display = "");

if (prodserv) {
  hideElement(prodserv);
}

if (periodo_dias) {
  hideElement(periodo_dias);
}

if (cliente_relatorio) {
  hideElement(cliente_relatorio);
}

if (data) {
  hideElement(data);
}

if (tipo_relatorio) {
  tipo_relatorio.addEventListener("change", (e) => {
    if (document.getElementById("prod_serv")) {
      document.getElementById("prod_serv").value = "";
    }
    if (document.getElementById("data_inicio")) {
      document.getElementById("data_inicio").value = "";
    }
    if (document.getElementById("data_fim")) {
      document.getElementById("data_fim").value = "";
    }
    if (document.getElementById("cliente_relatorio")) {
      document.getElementById("cliente_relatorio").value = "";
    }
    if (document.getElementById("data_controle")) {
      document.getElementById("data_controle").value = "";
    }

    if (e.target.value === tipo_relatorio.value) {
      if (
        tipo_relatorio.value == "relatorio_salada" ||
        tipo_relatorio.value == "relatorio_sobremesa_bebida" ||
        tipo_relatorio.value == "relatorio_marmita"
      ) {
        showElement(prodserv);
        showElement(data);
      } else if (
        tipo_relatorio.value == "pedidos_periodo" ||
        tipo_relatorio.value == "almoco_periodo" ||
        tipo_relatorio.value == "jantar_periodo" ||
        tipo_relatorio.value == "ceia_periodo" ||
        tipo_relatorio.value == "refeicoes_periodo" ||
        tipo_relatorio.value == "servicos_periodo" ||
        tipo_relatorio.value == "somatorio_refeicoes_periodo" ||
        tipo_relatorio.value == "somatorio_servicos_periodo" ||
        tipo_relatorio.value == "balanco_semanal_servicos" ||
        tipo_relatorio.value == "comensais_geral_periodo" ||
        tipo_relatorio.value == "comensais_periodo" ||
        tipo_relatorio.value == "balanca_geral_periodo" ||
        tipo_relatorio.value == "balanca_geral_periodo_por_data" ||
        tipo_relatorio.value == "balanca_rota_periodo_almoco" ||
        tipo_relatorio.value == "balanca_rota_periodo_jantar" ||
        tipo_relatorio.value == "pedidos_geral_periodo"
      ) {
        showElement(periodo_dias);
        hideElement(cliente_relatorio);
      } else if (
        tipo_relatorio.value == "eventos_periodo" ||
        tipo_relatorio.value == "checking_faturamento" ||
        tipo_relatorio.value == "faturamento_philips" ||
        tipo_relatorio.value == "faturamento_medical" ||
        tipo_relatorio.value == "faturamento_da" ||
        tipo_relatorio.value == "faturamento_geral" ||
        tipo_relatorio.value == "conferencia_compacta"
      ) {
        showElement(periodo_dias);
      } else if (tipo_relatorio.value == "pedidos_dia") {
        hideElement(prodserv);
        hideElement(data);
      } else if (
        tipo_relatorio.value == "cliente_periodo" ||
        tipo_relatorio.value == "balanco_mensal_servicos_cliente" ||
        tipo_relatorio.value == "comensais_filial_periodo" ||
        tipo_relatorio.value == "monitoramento_estoque_filial_periodo" ||
        tipo_relatorio.value == "analise_estoque_filial_periodo" ||
        tipo_relatorio.value == "c_comensais_pedidos_periodo" ||
        tipo_relatorio.value == "balanca_filial_periodo"
      ) {
        showElement(periodo_dias);
        showElement(cliente_relatorio);
      } else if (tipo_relatorio.value == "ultimo_envio_produtos_filial") {
        showElement(cliente_relatorio);
      }
    }
  });
}
